import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { customStyle } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

function SubdivisionDetails({
  formData,
  setFormData,
  validateForm,
  inquireMachineryApplication,
  transactionCode,
  getMachineryTaxEffectivityPeriod,
  taxEffectivityPeriod,
}) {
  const [machineryApplication, setMachineryApplication] = useState({});

  const yearOptions = useMemo(
    () =>
      taxEffectivityPeriod.map((item) => ({
        label: item?.year,
        value: item?.year,
      })),
    [taxEffectivityPeriod]
  );

  const quarterOptions = useMemo(
    () =>
      taxEffectivityPeriod.find(
        (item) => item?.year === +formData?.tax_effectivity_year
      )?.quarter ?? []
  ).map(
    (item) => ({
      label: quarterList.find((qtr) => +qtr.value === +item)?.label,
      value: item,
    }),
    [taxEffectivityPeriod, formData?.tax_effectivity_year]
  );

  const handleOnChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const handleOnSearch = () => {
    inquireMachineryApplication(
      { tdn: formData.tdn, rptax_transaction_code_id: transactionCode },
      (res) => {
        setFormData({ ...formData, machinery_application_id: res?.data?.id });
        setMachineryApplication({
          tdn: res?.data?.attributes?.tdn,
          pin: res?.data?.attributes?.pin,
        });
      }
    );
  };

  const handleRemoveItem = () => {
    setFormData({
      ...formData,
      machinery_application_id: '',
      number_of_parcels: '',
    });
    setMachineryApplication({});
  };

  useEffect(() => {
    if (formData?.machinery_application_id) {
      getMachineryTaxEffectivityPeriod(formData?.machinery_application_id, {
        rptax_transaction_code_id: transactionCode,
      });
    }
  }, [formData?.machinery_application_id, transactionCode]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <div className="row">
      <div className="col-6 form-group">
        <label htmlFor="last_name" className="form-label mb-0">
          TDN/ARP No.
          {validateForm.renderMessage('tdn')}
        </label>
        <div
          className="input-group mb-3 col-12 mt-2"
          style={{ marginLeft: -15 }}
        >
          <InputMask
            className="form-control"
            mask="aa-99999-99999"
            alwaysShowMask
            type="text"
            name="tdn"
            onChange={handleOnChange}
            value={_.get(formData, 'tdn') ?? ''}
          />
          <div className="input-group-append">
            <button
              disabled={
                _.get(formData, 'tdn') === '__-_____-_____' ||
                _.get(formData, 'tdn') === ''
              }
              type="button"
              onClick={handleOnSearch}
              className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
            >
              <span className="icon">
                <i className="fa fa-lg fa-search" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="col-6 form-group" />
      <div className="col-12 form-group">
        <table
          className="table table-sm table-hover"
          style={{ minWidth: '250px' }}
        >
          <thead className="table-header">
            <tr>
              <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                ARP/TDN
              </th>
              <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                PIN
              </th>
              <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(machineryApplication) && (
              <tr>
                <td className="p-3">{machineryApplication.tdn}</td>
                <td className="p-3">{machineryApplication.pin}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-link"
                    onClick={handleRemoveItem}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="col-6 form-group">
        <label className="form-label">
          Number of Parcels {validateForm.renderMessage('number_of_parcels')}
        </label>
        <input
          className="form-control"
          type="number"
          name="number_of_parcels"
          onChange={handleOnChange}
          value={_.get(formData, 'number_of_parcels') ?? ''}
        />
      </div>
      <div className="col-6 form-group" />
      <div className="col-6 form-group">
        <label htmlFor="tax_effectivity_year" className="form-label mb-0">
          Tax Effectivity Year &nbsp;{' '}
          {validateForm.renderMessage('tax_effectivity_year')}
        </label>
        <Select
          options={yearOptions}
          styles={customStyle}
          placeholder="Select Year"
          value={yearOptions.find(
            (item) => item.value === _.get(formData, 'tax_effectivity_year')
          )}
          onChange={handleSelected('tax_effectivity_year')}
          isDisabled={_.isEmpty(formData?.machinery_application_id)}
        />
      </div>
      <div className="col-6 form-group">
        <label htmlFor="tax_effectivity_quarter" className="form-label mb-0">
          Tax Effectivity Quarter: &nbsp;{' '}
          {validateForm.renderMessage('tax_effectivity_quarter')}
        </label>
        <Select
          styles={customStyle}
          placeholder="Select Quarter"
          value={
            quarterOptions.filter(
              (item) =>
                `${item.value}` === _.get(formData, 'tax_effectivity_quarter')
            )[0]
          }
          options={quarterOptions}
          onChange={handleSelected('tax_effectivity_quarter')}
          isDisabled={
            formData?.tax_effectivity_year === '' ||
            formData?.tax_effectivity_year === undefined ||
            _.isEmpty(formData?.machinery_application_id)
          }
        />
      </div>
    </div>
  );
}

SubdivisionDetails.defaultProps = {};

SubdivisionDetails.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.string.isRequired,
  inquireMachineryApplication: PropTypes.instanceOf(Function).isRequired,
  getMachineryTaxEffectivityPeriod: PropTypes.instanceOf(Function).isRequired,
  taxEffectivityPeriod: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxEffectivityPeriod:
    _.get(api, `${c.GET_MACHINERY_TAX_EFFECTIVITY_PERIOD}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(SubdivisionDetails);
